import { CanopyClient } from '@canopy-pte-ltd/canopy-toolkit';
import apiClient from '.';
class MMAnalyticsClient extends CanopyClient {
    constructor(apiServer: string) {
        super({
            apiServer,
            persistSession: true,
            apiVersion: 'v2',
            appId: 'canopy_manager',
        });
    }

    async fetcher(url: string, endpointVersion: string) {
        if (!url) {
            return null;
        }
        try {
            const response: any =
                (await this.get(url, {
                    apiVersion: endpointVersion,
                    headers: {
                        ...apiClient.headers,
                    },
                    replaceHeaders: true,
                })) || {};
            if (response.status !== 200) {
                throw 'An error occurred while fetching the data.';
            }
            return response?.data;
        } catch (e: any) {
            throw (
                e?.response?.data?.error ||
                e?.response?.data?.Error ||
                e?.response?.data?.message ||
                e?.data?.error ||
                e?.data?.message ||
                e?.data?.Error ||
                'An error occurred while fetching the data.'
            );
        }
    }
}

export default new MMAnalyticsClient(
    process.env.REACT_APP_ANALYTICS_API ||
        'https://analytics-api-dev.kurtosys.org/'
);
